import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';

import { AutoSimulateModalAb } from './autoSimulate.ab';
import { AutoSimulateModalBcp } from './autoSimulate.bcp';

export const AutoSimulateModal = () => {
	return (
		<RenderComponent
			components={{
				ab: {
					desktop: <AutoSimulateModalAb />,
					mobile: <AutoSimulateModalAb />,
					intranet: null,
				},
				bcp: {
					desktop: <AutoSimulateModalBcp />,
					mobile: <AutoSimulateModalBcp />,
					intranet: null,
				},
			}}
		/>
	);
};
